import { ButtonLink, Container, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { SecondaryNav } from '@/components';
import { MeasurementExplainer } from '@/components/NCExplainers/MeasurementExplainer';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useIsConservation } from '@/hooks/useIsConservation';
import { useMembershipType } from '@/hooks/useMembershipType';
import { useScreenSize } from '@/hooks/useScreenSize';
import { useActiveWidgetSlotConfiguration } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { paths } from '@/routing';

import { useMenuItems } from '../hooks/useMenuItems';
import { ProjectsList } from './components/projectList/ProjectsList';
import { ConservationProjectsMap } from './components/projectsMap/ConservationProjectsMap';

export const ProjectsPage = () => {
  const { t } = useTranslation();

  const menuItems = useMenuItems();
  const isSmallScreen = useScreenSize() === 'small';
  const membershipType = useMembershipType();

  const isConservation = useIsConservation();

  const widgetSlotsConfiguration = useActiveWidgetSlotConfiguration(
    DefaultWidgetNames.default_template_investments,
    WidgetType.t_page,
  );

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <SecondaryNav
        title={t('shared.navbar.projects')}
        action={
          isConservation ? (
            <Stack direction='row' spacing={6}>
              {!isSmallScreen && <MeasurementExplainer />}
              {membershipType === MembershipWithOrganizationTypeEnum.land_steward && (
                <ButtonLink to={paths.landSteward.newProject}>{t('shared.navbar.labels.createProject')}</ButtonLink>
              )}
            </Stack>
          ) : null
        }
      />
      {isConservation ? (
        <Container
          contentWidth='lg'
          className='gap-10 pb-10 pt-8'
          gutterWidth={{ sm: 4, md: 10 }}
          data-testid='project-map-wrapper'
        >
          <div className='h-[60vh] animate-in fade-in'>
            <ConservationProjectsMap />
          </div>

          <ProjectsList />
        </Container>
      ) : (
        <Container contentWidth='lg' className='gap-10 pb-10 pt-8' gutterWidth={{ sm: 4, md: 10 }}>
          <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
          <ProjectsList />
        </Container>
      )}
    </SignedInPageLayout>
  );
};
